import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/crawls/')({ component: NoRequestOpen })

/**
 * The crawls page with no log open.
 *
 * Nothing of its own: the table is the layout's, and this exists so that
 * `/admin/crawls` is a route in its own right rather than the layout's only
 * shape. Opening a request adds the panel beside the table rather than
 * replacing anything.
 */
function NoRequestOpen() {
  return null
}
